import React, { FC } from 'react';
import Modal from 'react-modal';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import closeIcon from '../../images/close.svg';
import CompanyLogo from '../../images/CompanyLogo.png';
import { useGlobalState } from '../../Providers';

interface CopyrightModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const CopyrightModal: FC<CopyrightModalProps> = ({ isOpen, onClose }) => {
    const { translate } = useLocale();
    const year = new Date().getFullYear();
    const { buildInfo } = useGlobalState() ?? {}; 

    return <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        overlayClassName="flex w-screen position-float fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
        className="bg-white border-none m-auto shadow select-none outline-none overflow-hidden" >
        <div className={`w-full p-2 border-b flex flex-row items-center bg-sidemenu-focus text-white justify-between`}>
            <div className="flex flex-row">
                <p className="pl-3 font-bold font text-white">{translate.byKey(TranslationKeys.copyright)}</p>
            </div>
            <img src={closeIcon} data-testid="modal_closeCopyright" onClick={onClose} className="cursor-pointer mr-2" />
        </div>
        <div className="pb-3" style={{ width: '360px', }}>
            <div className='flex flex-row'>
                <div className='pl-4 pt-4'>
                    <img src={CompanyLogo} className='h-20'/>
                </div>
                <div className='flex flex-col pl-4 pt-4'>
                    <span className='font-bold'>{buildInfo?.companyName}</span>
                    <span className='text-sm'>{translate.byKey(TranslationKeys.copyrightAllRightsReserved)} &copy; {year}</span>
                    <span className='text-sm cursor-pointer pb-2 text-portal-blue-primary' onClick={() => window.open(`${buildInfo?.companyWebsite}`, '_blank')}>{buildInfo?.companyWebsite}</span>
                </div>
            </div>
        </div>
    </Modal>
}

export default CopyrightModal;
